import { Cookie } from '@repo/tools'
import { getAgentPasswordSettings } from './password-settings.service'

export const agentPasswordSettingsOptions = (enabled: boolean) => ({
  queryKey: ['agent-password-settings'],
  queryFn: getAgentPasswordSettings,
  enabled: !!Cookie.get('access_token') && enabled,
})
